(() => {
  var __webpack_exports__ = {};
  var isDefined = customElements.get('localization-form');

  if (!isDefined) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.thing = 0;

        this.elements = {
          input: this.querySelector('input[name="language_code"],input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('#LanguageList'),
        };

        // Debug log to confirm initialization
        console.log('LocalizationForm initialized.');

        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        // Attach event listeners to all <a> elements inside the form
        this.querySelectorAll('a').forEach(item => {
          console.log('Attaching click event listener to:', item); // Debugging event attachment
          item.addEventListener('click', this.onItemClick.bind(this)); // Bind the click event for each <a> tag
        });
      }

      // Handle hiding the panel
      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.classList.remove('open');  // Remove 'open' class to hide the panel
      }

      // Handle key events (ESC to close)
      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      // Handle language/country selection
      onItemClick(event) {
        console.log("Click event triggered..."); // Debugging if click is fired

        event.preventDefault(); // Prevent default anchor behavior

        const selectedValue = event.currentTarget.dataset.value; // Get the selected value
        console.log("Selected Value:", selectedValue); // Log selected value

        // Update the hidden input field with the selected value (country or language)
        if (this.elements.input) {
          this.elements.input.value = selectedValue;
          console.log("Updated Hidden Input Value:", this.elements.input.value); // Log updated input value
        } else {
          console.log("Hidden input not found!"); // If input element isn't found, log an error
        }

        // Manually trigger form submission to check if the issue lies with submission or input handling
        const form = this.querySelector('form');
        if (form) {
          console.log("Triggering form submit...");
          form.submit(); // Submit the form to trigger the page refresh
        } else {
          console.log("Form element not found!"); // Log error if form element is not found
        }
      }

      // Open the selector panel
      openSelector() {
        this.elements.button.focus();
        this.elements.panel.classList.add('open');  // Add 'open' class to show the panel
        this.elements.button.setAttribute('aria-expanded', 'true');
      }

      // Close the selector panel
      closeSelector(event) {
        const shouldClose = !event.relatedTarget?.classList?.contains('disclosure__item_el');
        if (shouldClose) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }
})();
